<template>
    <a-modal v-model:visible="visible" title="全部消息" okText="确认" okType="primary" width="600px" height="600px"
        @cancel="onClose" footer="">
        <div class="boxInfo">
            <div class="boxNews" v-for="(item, index) in infoIndex" :key="index">
                <div class="boxNewsIn">
                    <div class="newTop">
                        <span>{{ item.msg_category === '1' ? '通知公告' : '系统消息' }}：{{ item.titile }}</span>
                        <span class="titleInfo" @click="lookInfo(item)">查看详情</span>
                    </div>
                    <div>{{ item.sendTime }}</div>
                </div>
            </div>
        </div>
        <!-- 查看详情弹窗 -->
        <template>
            <a-modal title="查看详情" v-model:visible="visible1" okText="确认" okType="primary" width="600px" footer="">
                <div class="box">
                    <div class="boxTop">
                        <div class="title">{{ infoMessage.titile }}</div>
                        <div class="titleBottom">
                            <span>发布人：{{ infoMessage.create_by }}</span>
                            <span style="margin-left: 10px;">发布时间：{{ infoMessage.sendTime }}</span>
                        </div>
                    </div>
                    <div class="boxBottom">
                        <div class="title">{{ infoMessage.msg_category === '1' ? '通知公告' : '系统消息' }}</div>
                        <div class="titleBottom">
                            <div>通知时间：{{ infoMessage.create_time }}</div>
                            <div>通知内容：{{ infoMessage.msg_abstract }}</div>
                        </div>
                    </div>
                </div>
            </a-modal>
        </template>
    </a-modal>
</template>
<script  setup>
import { ref, defineEmits, onMounted } from "vue";
import { announcementUserApi } from '@/api/messageCenterApi/messageCenterApi'
import { announcementSendApi } from '@/api/messageCenterApi/messageCenterApi'

const visible = ref(true)
const emits = defineEmits(['close', 'upDataCount'])
const onClose = () => {
    emits('close')
}
const infoIndex = ref([])
const initFn = () => {
    announcementUserApi().then(res => {
        infoIndex.value = res.data.data
    })
}

//查看详情
//查看详情弹窗
const visible1 = ref(false)
const infoMessage = ref({})
const lookInfo = (row) => {
    visible1.value = true
    infoMessage.value = row
    announcementSendApi({ id: row.id }).then(() => {
        emits('upDataCount')
    })
}

onMounted(() => {
    initFn()
})


</script>
<style lang="scss" scoped>
.boxInfo {
    width: 100%;
    height: 600px;
    // background-color: rosybrown;
    overflow: scroll;

    .boxNews {
        height: 80px;
        width: 100%;
        // background-color: wheat;
        border-bottom: 1px solid #eee;

        .boxNewsIn {
            margin-left: 20px;

            .newTop {
                margin-bottom: 10px;

                .titleInfo {
                    margin-left: 10px;
                    color: rgba(103, 182, 255);
                    margin-bottom: 30px;
                    cursor: pointer;
                }
            }
        }

        .newTop {
            width: 100%;
            height: 100%;
            margin-top: 10px;

        }
    }
}

.box {
    width: 98%;
    height: 300px;
    /* background-color: bisque; */
    border: 1px solid #eee;

    .boxTop {
        margin-left: 30px;
        margin-top: 30px;
        width: 90%;
        // margin: 10px;
        height: 30%;
        border-bottom: 1px solid #eee;
        // background-color: yellow;

        .title {
            font-size: 16px;
            font-weight: 600;
        }

        .titleBottom {
            margin-top: 20px;
            color: #8c8c8c;
        }
    }

    .boxBottom {
        margin-left: 30px;
        margin-top: 20px;

        .title {
            font-size: 16px;
            font-weight: 600;
        }

        .titleBottom {
            margin-top: 20px;
            color: #8c8c8c;
        }
    }
}
</style>